<template>
    <div class="chatControls">
        <div class="chatPagination">
            <i v-if="Math.max(Math.ceil(allClientMessages.length / pageSize), 1) > 1" class="fa fa-arrow-circle-left" @click="prevPage"></i>
            <div class="chatPaginationText">
                Seite {{currentPage}} von {{ Math.max(Math.ceil(allClientMessages.length / pageSize), 1)}}
            </div>
            <i v-if="Math.max(Math.ceil(allClientMessages.length / pageSize), 1) > 1" class="fa fa-arrow-circle-right" @click="nextPage"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Chatcontrols',
        props: ['allClientMessages', 'currentPage', 'pageSize'],
        data() {
            return {
                checked: false,
            }
        },
        methods: {
            prevPage: function () {
                this.$emit('prevpage');
            },
            nextPage: function () {
                this.$emit('nextpage');
            },
            checkOverlay: function () {
                this.$emit('overlayChecked');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chatControls {
        padding: 10px 10px 10px 10px;
        border-radius: 7px;
        margin: 15px 0 0 0;
        display: flex;
        justify-content: flex-end;
        font-weight: bold;

        .previewCheckbox {
            display: flex;
            flex-wrap: nowrap;
        }
    }

    .chatPagination {
        font-size: 14px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .fa {
            margin: 0;
            cursor: pointer;
        }

        .chatPaginationText {
            display: flex;
            justify-content: space-around;
            width: 120px;
        }
    }
</style>
